import { window } from "global";
import React, { useState, useEffect } from "react";
import { SEND_PAGE_COUNT } from "components/GoogleAnalyticsWrapper";

let LOADED = {};

const AdComponent = (props) => {
  const {
    slotId,
    style,
    // shouldChangeForRoute = () => {},
    // backupAd
  } = props;

  let [firstLoaded, setFirstLoaded] = useState(true);

  useEffect(() => {
    // only call egAps.render on first website page load
    // console.log("SEND_PAGE_COUNT", SEND_PAGE_COUNT, firstLoaded);
    if (firstLoaded && SEND_PAGE_COUNT === 1) {
      // console.log("RENDER", slotId);
      if (window && window.egAps && typeof window.egAps.render === "function") {
        egAps.render([slotId]);
      }
      setFirstLoaded(false);
    }
  }, []);

  // Because of how ads injects another wrapper, it will throw an error when trying to unmount an unknown parent node
  // In order to prevent this, we need to create our own wrapper div so React knows what node to mount/unmount

  // Injected node from ads
  // <div data-adunit-name="slotId"><div id="slotId"></div></div>
  return (
    <div className="ad-component-wrapper" style={{ display: "contents" }}>
      <div id={slotId} style={style} className="ads-background"></div>
    </div>
  );
};

export default AdComponent;
